import { styled, Grid, Box, Text } from '@ltvco/refresh-lib/theme';

export const PhoneSearchFieldContainer = styled(Grid)<{ error?: boolean }>(
  ({ theme, error }) => ({
    display: 'flex',
    alignItems: 'center',
    backgroundColor: theme.palette.background.paper,
    width: '100%',
    margin: theme.spacing(4, 0),

    [theme.breakpoints.down('sm')]: {
      margin: 0,
    },

    '& .iti__tel-input, & input': {
      height: '58px',
      border: `1px solid ${
        error ? theme.palette.error.main : theme.palette.text.disabled
      }`,
      borderRadius: '32px',
      margin: '0',

      '&:focus': {
        border: `1px solid ${
          error ? theme.palette.error.main : theme.palette.primary.main
        }`,
      },
    },

    '& .iti__selected-country-primary': {
      borderRadius: '32px 0 0 32px',
      paddingLeft: '20px',
    },

    '& .iti__flag': {
      transform: 'scale(1.2)',
    },
  })
);

export const PhoneFormContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.spacing(2),
  width: '100%',
}));

export const FormHelperErrorText = styled(Text)(({ theme }) => ({
  position: 'relative',
  fontSize: '12px',
  marginTop: 0,
  paddingTop: 0,
  color: theme.palette.error.main,

  [theme.breakpoints.down('sm')]: {
    marginTop: theme.spacing(1),
  },
}));
